var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cover",class:{'active' : _vm.menu_open},on:{"click":_vm.closeMenu}})
}
var staticRenderFns = []

export { render, staticRenderFns }